var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{svgwrap:true,active:_vm.active}},[_c('span',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('Icon',{staticClass:"svg",attrs:{"type":_vm.type,"colour":_vm.active?'#f1492a':''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }